import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ServiceCreate from '../../components/service/ServiceCreate';
import ServiceCreateByErrorCode from '../../components/service/ServiceCreateByErrorCode';
import { ServiceConstant } from '../../actions/constants/ServiceConstant';
import { Translate as t } from '../../config/Translate';
import { history } from '../../history';
import { AlertAction } from '../../actions/AlertAction';
import { store } from '../../store';
import { getReferExtra } from '../../lib/serviceCreateRefer';

const AdminServiceAdd = (props) => {
	const { refer, item, extraItem } = (props.location && props.location.state) || {};
	const dispatch = useDispatch();

	useEffect(() => {
		// F-004 (BUG-224 동일 클래스 차단): 직전 열람 티켓이 redux 에 잔존하면 ServiceClaimCategory 가 그 티켓을 갱신 → mount 시 초기화
		dispatch({ type: ServiceConstant.CLEAER });
	}, []);

	const callbackCreated = (service) => {
		if (!service?.ticketKey) {
			store.dispatch(AlertAction.ErrorMsg(t('service.message.createFailed') || 'Service creation failed. Please try again.'));
			return;
		}
		history.push('/Admin/AdminService/' + service.ticketKey);
	};

	return (
		<>
			<div className="extraHeader">
				<h2 className="mb-0">{t('service.button.addNew')}</h2>
				<div className="ray-right">
					{!refer &&
						<Link to="/Admin/AdminServiceList" className="btn btn-outline-default btn-sm mt-0 me-1">
							{t('common.label.list')}
						</Link>
					}
				</div>
			</div>
			<div id="appCapsule" className="extra-header-active full-height">
				{refer && (
					<ServiceCreateByErrorCode
						withBack={true}
						callbackCreated={callbackCreated}
						referErrorCode={item}
						referProduct={getReferExtra(refer, extraItem, "product")}
						referSite={getReferExtra(refer, extraItem, "site")}
					/>
				)}
				{!refer &&
					<ServiceCreate callbackCreated={callbackCreated} withBack={true} />
				}
			</div>
		</>
	);
};

export default AdminServiceAdd;
